import { fileToText } from "/src/js/utils/fileToText"
import { markdownToHtml } from "/src/js/utils/markdownToHtml"

async function convert() {
    const markdown = await fileToText("/legal/privacy.md")
    const html = await markdownToHtml(markdown)

    document.querySelector(".section").innerHTML = html
}

convert()
